// @ts-nocheck

import React from 'react';
import { useEffect, useMemo, useState } from 'react';

import { __ } from '../../i18n/l10n';
import { type FacetType } from '../../types/facets';
import { Routes } from '../../types/routes';
import MatchRowList from '../MatchRowList';
import MatchRowsFilters from '../MatchRowsFilters';
import NotFoundView from '../NotFoundView';
import WinaLoader from '../WinaLoader';

type RoutesCalendarProps = {
  isLoading: boolean;
  list: Array<unknown>;
  facets: Array<FacetType> | null;
  prefs: unknown;
  setPreferences: (prefs: unknown) => void;
  askRoute: (route: Route) => void;
  anchorMatchId: string;
};

const RoutesCalendar = ({
  isLoading,
  list,
  facets,
  prefs,
  setPreferences,
  askRoute,
  anchorMatchId,
}: RoutesCalendarProps) => {
  const hasAnyResult = useMemo(() => !!facets?.filter((facet) => facet.count > 0)?.length, [facets]);
  const [scrollTop, setScrollTop] = useState(false);

  useEffect(() => {
    askRoute(`${Routes.CALENDAR}:24`);
  }, [askRoute]);

  if (isLoading) {
    return <WinaLoader delayed />;
  }

  return (
    <section className="event-list">
      {hasAnyResult ? (
        <>
          <MatchRowsFilters facets={facets} prefs={prefs} setPreferences={setPreferences} setScrollTop={setScrollTop} />
          <MatchRowList items={list} anchorMatchId={anchorMatchId} setScrollTop={setScrollTop} scrollTop={scrollTop} />
        </>
      ) : null}
      {!hasAnyResult ? <NotFoundView label={__('no events')} /> : null}
    </section>
  );
};

export default RoutesCalendar;
